export class StringHelper {
	/**
	 * Capitalizes the first letter for each word and sets the rest to lowercase
	 * @param str
	 */
	public static toTitleCase(str) {
		return str.replace(/\w\S*/g, txt => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase());
	}

	/**
	 * Capitalizes the first letter of a string
	 * @param str
	 */
	public static capitalize(str: string): string {
		return str.charAt(0).toUpperCase() + str.slice(1);
	}
}
